import { ToggleButton, ToggleButtonProps } from '@fluentui/react-components';
import { BrainSparkleRegular } from '@fluentui/react-icons';

import { ControlledTooltip } from '@shared/components';
import useGroundedQaTerminology from '../hooks/useGroundedQaTerminology.hook';

type TProps = {
  appearance?: ToggleButtonProps['appearance'];
  size?: ToggleButtonProps['size'];
  checked: boolean;
  onClick: () => void;
  disabledTooltip?: string;
};

const AiAssistantButton = ({ appearance, size = 'small', checked, onClick, disabledTooltip }: TProps) => {
  const isDisabled = Boolean(disabledTooltip);
  const iconClass = appearance === 'primary' ? '!text-aiAccentPrimary' : '!text-aiAccentSecondary';
  const { short: groundedQaShortLabel } = useGroundedQaTerminology();

  return (
    <ControlledTooltip
      enable={isDisabled}
      content={disabledTooltip ?? ''}
      relationship="inaccessible"
      positioning="below"
      withArrow
    >
      <ToggleButton
        size={size}
        appearance={appearance}
        checked={!isDisabled && checked}
        disabled={isDisabled}
        icon={<BrainSparkleRegular className={iconClass} />}
        // AiAssistant's overlay closes on outside-mousedown; this button sits outside its root.
        onMouseDown={(e) => e.stopPropagation()}
        onClick={onClick}
        className="!min-w-0"
      >
        {groundedQaShortLabel}
      </ToggleButton>
    </ControlledTooltip>
  );
};

export default AiAssistantButton;
